const removeWhiteSpaces = (value?: string): string | undefined => value && value.trim();

export default removeWhiteSpaces;
